<app-title-bar titleText="i18n.base.forgot-password.header"></app-title-bar>
<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    @if (!forgotPasswordSuccess) {
      <form [formGroup]="forgotPasswordForm">
        <p>{{ "i18n.base.forgot-password.info" | translate }} <br/> {{ "i18n.base.forgot-password.disclaimer" | translate }}</p>
        <div class="form-group">
          <label for="userName">{{ "i18n.base.forgot-password.userName" | translate }}</label>
          <input id="userName" class="form-control" formControlName="userName" appRequired>
          <app-error-messages [control]="formFields.userName"></app-error-messages>
        </div>
        <button type="submit" class="btn btn-primary btn-right" (click)="formSubmit()" [disabled]="!forgotPasswordForm.valid">
          {{ "i18n.base.forgot-password.submit-button" | translate }}
        </button>
        <a type="button" class="btn btn-outline-secondary btn-right me-3" [routerLink]="loginRoute">
          {{ "i18n.base.forgot-password.back-button" | translate }}
        </a>
      </form>
    }
    @if (forgotPasswordSuccess) {
      <div>
        <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.forgot-password.success-info" | translate }}</p>
        <button type="submit" class="btn btn-primary btn-right" (click)="forgotPasswordSuccess = false">
          {{ "i18n.base.forgot-password.try-again" | translate }}
        </button>
      </div>
    }
  </div>
</div>
